import { z } from 'zod';

export const CatalogItemSchema = z.object({
  id: z.string(),
  url: z.string(), // Imagen principal (o "Después" / "Resultado")
  beforeUrl: z.string().nullable().optional(), // Imagen secundaria para comparaciones
  caption: z.string().nullable().optional(),
  order: z.number().default(0),
});

export const LinkItemSchema = z.object({
  id: z.string(),
  label: z.string().min(1, 'El nombre es obligatorio'),
  url: z.string().url('URL inválida'),
  order: z.number().default(0),
});

export const CatalogSectionSchema = z.object({
  id: z.string(),
  title: z.string().min(2, 'El título es muy corto'),
  type: z.enum(['grid', 'carousel', 'comparison', 'links', 'hub']).default('grid'),
  images: z.array(CatalogItemSchema).default([]),
  links: z.array(LinkItemSchema).optional().default([]),
  isActive: z.boolean().default(true),
  order: z.number().default(0),
  comparisonLabels: z
    .object({
      left: z.string().default('Antes'),
      right: z.string().default('Después'),
    })
    .optional(),
});

export type CatalogSection = z.infer<typeof CatalogSectionSchema>;
export type CatalogItem = z.infer<typeof CatalogItemSchema>;
export type LinkItem = z.infer<typeof LinkItemSchema>;
